export default __webpack_public_path__ + "0bf9f9ab126f3c89190f158f16b09dc3.png";